import { styled } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import config from '../../config.json';
import { pathOr } from 'rambda';

export const TooltipTrigger = ({
  name,
  toggleTooltip,
  offTooltip,
  submitActionHelpStyles = false,
}: {
  name: string;
  toggleTooltip: (tooltip: string) => void;
  offTooltip: (tooltip: string) => void;
  submitActionHelpStyles?: boolean;
}) =>
  submitActionHelpStyles ? (
    <Wrapper2
      onClick={() => toggleTooltip(name)}
      onBlur={() => offTooltip(name)}
      aria-label={pathOr('idk', name)(config)}
      type="button">
      <FontAwesomeIcon icon={faInfoCircle} size="1x" fixedWidth />
    </Wrapper2>
  ) : (
    <Wrapper
      onClick={() => toggleTooltip(name)}
      onBlur={() => offTooltip(name)}
      aria-label={pathOr('idk', name)(config)}
      type="button">
      <FontAwesomeIcon icon={faInfoCircle} size="1x" fixedWidth />
    </Wrapper>
  );

const Wrapper = styled('button')(({ theme }) => triggerStyles);
const Wrapper2 = styled('button')(({ theme }) => ({
  ...triggerStyles,
  ...submitActionHelpStyles,
}));

export const triggerStyles = {
  border: 'none',
  background: 'none',
  cursor: 'pointer',
};

const submitActionHelpStyles = {
  marginLeft: '0px',
};
